import cn from "classnames";
import { dateTimeToView } from "helpers/date";
import React from "react";

const BookItemStatus = (props) => {
    const changeStatus = () => {
        props.modal({
            name: "resourceActivityForm",
            title: props.title,
            windowMod: "wide",
            sendReq: props.setResourceActivity,
            callback: props.callback,
            initialData: {
                ...props.initialData,
                isActive: props.isActive,
                resourceInactivityInfo: props.resourceInactivityInfo,
            },
        });
    };
    return (
        <>
            <div>
                <div
                    className={cn("badge align-middle mr-2", {
                        "badge-success": props.isActive,
                        "badge-danger": !props.isActive,
                    })}
                >
                    {props.isActive ? "Активный" : "Неактивный"}
                </div>
                {props.canChangeStatus !== false && (
                    <small className="link align-middle" onClick={changeStatus}>
                        <i className="icon-uEA10-pen pr-1" />
                        Изменить
                    </small>
                )}
            </div>
            {!props.isActive && props.resourceInactivityInfo && (
                <>
                    <small>
                        <span className="nowrap">{dateTimeToView(props.resourceInactivityInfo.inactiveSince)}</span>
                        <span className="px-2">&mdash;</span>
                        <span className="nowrap">{dateTimeToView(props.resourceInactivityInfo.inactiveUntil)}</span>
                    </small>
                    <br />
                    <small className="text-muted">{props.resourceInactivityInfo.inactivityReason}</small>
                </>
            )}
        </>
    );
};

export default BookItemStatus;
